/**
 * converte as questions (estrutura de dados da store)
 * para uma estrutura de dados que será interpretada
 * pelo componente de seção.
 *
 * @param {*} questions
 */
function adaptQuestionsToData(surveys, selectedQIds) {
  // adapt
  const datas = [];
  surveys.forEach((survey) => {
    survey.perguntas.forEach((pergunta) => {
      const data = {
        value: { surveyId: survey.id, questionId: pergunta.id },
        label: pergunta.enunciado,
        group: survey.titulo,
      };
      datas.push(data);
    });
  });
  // checked
  const newDatas = [];
  datas.forEach((data) => {
    // default vale
    let checked = false;
    // for each selected data test if was selected
    selectedQIds.forEach((objId) => {
      const { surveyId, questionId } = objId;
      if (!checked && (
        surveyId === data.value.surveyId
        && questionId === data.value.questionId
      )) {
        checked = true;
      }
    });
    // add to new datas
    newDatas.push({
      checked,
      ...data,
    });
  });
  //
  return newDatas;
}

export { adaptQuestionsToData };
